// extracted by mini-css-extract-plugin
module.exports = {"poetry":"section-module--poetry--3kop4","bgPoetry":"section-module--bgPoetry--2wSj4","slider":"section-module--slider--T5YKL"};